// ===== ESTRUTURA ATUALIZADA BASEADA NO BACKEND ATUAL =====
// Reflete exatamente as entidades: User, Account, Role, Plan, Feature, Subscription
export const mockData = {
    // ===== FEATURES =====
    features: [
        {
            id: 'feature-dashboard-001',
            key: 'dashboard',
            name: 'Dashboard',
            description: 'Acesso ao dashboard principal',
            type: 'boolean',
            defaultValue: 'true',
            constraints: { required: true },
            isActive: true,
            isGlobal: true,
            metadata: {},
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'feature-analytics-001',
            key: 'analytics',
            name: 'Analytics',
            description: 'Acesso a relatórios e análises',
            type: 'boolean',
            defaultValue: 'false',
            constraints: { required: false },
            isActive: true,
            isGlobal: false,
            metadata: {},
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'feature-users-001',
            key: 'users',
            name: 'Gestão de Usuários',
            description: 'Gerenciar usuários da conta',
            type: 'boolean',
            defaultValue: 'false',
            constraints: { required: false },
            isActive: true,
            isGlobal: false,
            metadata: {},
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'feature-settings-001',
            key: 'settings',
            name: 'Configurações',
            description: 'Acesso às configurações da conta',
            type: 'boolean',
            defaultValue: 'true',
            constraints: { required: true },
            isActive: true,
            isGlobal: true,
            metadata: {},
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'feature-docs-001',
            key: 'docs',
            name: 'Documentação',
            description: 'Acesso à documentação',
            type: 'boolean',
            defaultValue: 'true',
            constraints: { required: true },
            isActive: true,
            isGlobal: true,
            metadata: {},
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        }
    ],
    // ===== PLANS =====
    plans: [
        {
            id: 'plan-free-001',
            name: 'Free',
            description: 'Plano gratuito com recursos básicos',
            type: 'free',
            price: 0.00,
            maxUsers: 1,
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z',
            features: ['feature-dashboard-001', 'feature-settings-001', 'feature-docs-001']
        },
        {
            id: 'plan-basic-001',
            name: 'Basic',
            description: 'Plano básico para pequenas equipes',
            type: 'basic',
            price: 29.90,
            maxUsers: 5,
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z',
            features: ['feature-dashboard-001', 'feature-settings-001', 'feature-docs-001', 'feature-analytics-001']
        },
        {
            id: 'plan-pro-001',
            name: 'Pro',
            description: 'Plano profissional com recursos avançados',
            type: 'pro',
            price: 99.90,
            maxUsers: 20,
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z',
            features: ['feature-dashboard-001', 'feature-settings-001', 'feature-docs-001', 'feature-analytics-001', 'feature-users-001']
        },
        {
            id: 'plan-enterprise-001',
            name: 'Enterprise',
            description: 'Plano empresarial com recursos ilimitados',
            type: 'enterprise',
            price: 299.90,
            maxUsers: null,
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z',
            features: ['feature-dashboard-001', 'feature-settings-001', 'feature-docs-001', 'feature-analytics-001', 'feature-users-001']
        }
    ],
    // ===== ROLES =====
    roles: [
        {
            id: 'role-superadmin-001',
            name: 'superadmin',
            description: 'Full system access',
            permissions: {
                'users.read': true,
                'users.write': true,
                'users.delete': true,
                'roles.read': true,
                'roles.write': true,
                'roles.delete': true,
                'system.admin': true
            },
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'role-admin-001',
            name: 'admin',
            description: 'Administrative access',
            permissions: {
                'users.read': true,
                'users.write': true,
                'content.moderate': true
            },
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'role-moderator-001',
            name: 'moderator',
            description: 'Limited administrative access',
            permissions: {
                'users.read': true,
                'users.write': true,
                'content.moderate': true
            },
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'role-user-001',
            name: 'user',
            description: 'Standard user access',
            permissions: {
                'profile.read': true,
                'profile.write': true
            },
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        }
    ],
    // ===== ACCOUNTS =====
    accounts: [
        {
            id: 'master-account-001',
            name: 'Sistema Principal',
            description: 'Conta principal do sistema',
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440001',
            name: 'Empresa ABC Ltda',
            description: 'Empresa de tecnologia',
            isActive: true,
            createdAt: '2025-01-15T10:00:00Z',
            updatedAt: '2025-01-15T10:00:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440004',
            name: 'Tech Solutions S.A.',
            description: 'Soluções em tecnologia',
            isActive: true,
            createdAt: '2025-01-20T09:15:00Z',
            updatedAt: '2025-01-20T09:15:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440007',
            name: 'Digital Marketing Pro',
            description: 'Marketing digital',
            isActive: true,
            createdAt: '2025-01-25T14:30:00Z',
            updatedAt: '2025-01-25T14:30:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440010',
            name: 'Consultoria Financeira XYZ',
            description: 'Consultoria financeira',
            isActive: true,
            createdAt: '2025-01-30T08:45:00Z',
            updatedAt: '2025-01-30T08:45:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440013',
            name: 'E-commerce Plus',
            description: 'E-commerce',
            isActive: true,
            createdAt: '2025-02-05T12:20:00Z',
            updatedAt: '2025-02-05T12:20:00Z'
        }
    ],
    // ===== SUBSCRIPTIONS =====
    subscriptions: [
        {
            id: 'sub-master-001',
            accountId: 'master-account-001',
            planId: 'plan-enterprise-001',
            status: 'active',
            startDate: '2025-07-30T00:00:00Z',
            endDate: '2026-07-30T00:00:00Z',
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        {
            id: 'sub-empresaabc-001',
            accountId: '550e8400-e29b-41d4-a716-446655440001',
            planId: 'plan-pro-001',
            status: 'active',
            startDate: '2025-07-30T00:00:00Z',
            endDate: '2025-08-30T00:00:00Z',
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        }
    ],
    // ===== USERS =====
    users: [
        // ===== MASTER ACCOUNT =====
        {
            id: 'master-user-001',
            name: 'Super Admin',
            email: 'superadmin@example.com',
            password: 'SuperAdmin123!',
            roleId: 'role-superadmin-001',
            accountId: 'master-account-001',
            avatar: 'https://picsum.photos/200/200?random=0',
            isActive: true,
            createdAt: '2025-07-30T00:00:00Z',
            updatedAt: '2025-07-30T00:00:00Z'
        },
        // ===== EMPRESA ABC LTDA =====
        {
            id: '550e8400-e29b-41d4-a716-446655440002',
            name: 'João Silva',
            email: 'admin@example.com',
            password: 'Admin123!',
            roleId: 'role-admin-001',
            accountId: '550e8400-e29b-41d4-a716-446655440001',
            avatar: 'https://picsum.photos/200/200?random=1',
            isActive: true,
            createdAt: '2025-01-15T10:00:00Z',
            updatedAt: '2025-01-15T10:00:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440003',
            name: 'Maria Santos',
            email: 'moderator@example.com',
            password: 'Moderator123!',
            roleId: 'role-moderator-001',
            accountId: '550e8400-e29b-41d4-a716-446655440001',
            avatar: 'https://picsum.photos/200/200?random=2',
            isActive: true,
            createdAt: '2025-01-16T14:30:00Z',
            updatedAt: '2025-01-16T14:30:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440004',
            name: 'Pedro Costa',
            email: 'user@example.com',
            password: 'User123!',
            roleId: 'role-user-001',
            accountId: '550e8400-e29b-41d4-a716-446655440001',
            avatar: 'https://picsum.photos/200/200?random=3',
            isActive: true,
            createdAt: '2025-01-18T11:20:00Z',
            updatedAt: '2025-01-18T11:20:00Z'
        },
        {
            id: '550e8400-e29b-41d4-a716-446655440005',
            name: 'Ana Oliveira',
            email: 'ana.oliveira@empresaabc.com',
            password: 'User123!',
            roleId: 'role-user-001',
            accountId: '550e8400-e29b-41d4-a716-446655440001',
            avatar: 'https://picsum.photos/200/200?random=4',
            isActive: true,
            createdAt: '2025-01-19T09:15:00Z',
            updatedAt: '2025-01-19T09:15:00Z'
        }
    ],
    // ===== HELPER FUNCTIONS =====
    // Função para obter usuário por email
    getUserByEmail: (email) => {
        return mockData.users.find(user => user.email === email);
    },
    // Função para obter todos os usuários
    getAllUsers: () => {
        return mockData.users;
    },
    // Função para obter usuários por conta
    getUsersByAccount: (accountId) => {
        return mockData.users.filter(user => user.accountId === accountId);
    },
    // Função para obter conta por ID
    getAccountById: (accountId) => {
        return mockData.accounts.find(account => account.id === accountId);
    },
    // Função para obter todas as contas com usuários
    getAccountsWithUsers: () => {
        return mockData.accounts.map(account => ({
            ...account,
            users: mockData.getUsersByAccount(account.id)
        }));
    },
    // Função para obter role por ID
    getRoleById: (roleId) => {
        return mockData.roles.find(role => role.id === roleId);
    },
    // Função para obter todas as roles
    getAllRoles: () => {
        return mockData.roles;
    },
    // Função para obter plano por ID
    getPlanById: (planId) => {
        return mockData.plans.find(plan => plan.id === planId);
    },
    // Função para obter subscription ativa de uma conta
    getActiveSubscription: (accountId) => {
        return mockData.subscriptions.find(sub => sub.accountId === accountId && sub.status === 'active');
    },
    // Função para obter features de um plano
    getPlanFeatures: (planId) => {
        const plan = mockData.plans.find(p => p.id === planId);
        if (!plan)
            return [];
        return plan.features.map(featureId => mockData.features.find(f => f.id === featureId)).filter(Boolean);
    },
    // Função para verificar se usuário tem feature
    userHasFeature: (userId, featureKey) => {
        const user = mockData.users.find(u => u.id === userId);
        if (!user)
            return false;
        const subscription = mockData.getActiveSubscription(user.accountId);
        if (!subscription)
            return false;
        const planFeatures = mockData.getPlanFeatures(subscription.planId);
        return planFeatures.some(f => f?.key === featureKey);
    },
    // ===== DASHBOARD STATS (mantendo dados existentes + Instagram) =====
    dashboardStats: {
        totalUsers: 1250,
        totalAccounts: 45,
        totalRevenue: 125000,
        totalOrders: 890,
        totalViews: 45780,
        totalSales: 125000,
        totalProducts: 156,
        monthlyRevenue: 28500,
        totalComponents: 42,
        // Dados de usuários por mês (últimos 12 meses)
        usersByMonth: {
            categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            series: [{
                    name: 'Novos Usuários',
                    data: [65, 78, 92, 85, 98, 112, 125, 108, 95, 118, 132, 145]
                }, {
                    name: 'Usuários Ativos',
                    data: [45, 58, 72, 65, 78, 92, 105, 88, 75, 98, 112, 125]
                }]
        },
        // Dados de receita por categoria
        revenueByCategory: {
            categories: ['Assinaturas', 'Vendas Únicas', 'Consultoria', 'Suporte'],
            series: [{
                    name: 'Receita (R$)',
                    data: [45000, 28000, 35000, 17000]
                }]
        }
    },
    // ===== INSTAGRAM STATS (mantendo funcionalidade adicional) =====
    instagramStats: {
        followers: 125000,
        following: 1250,
        posts: 890,
        engagement: 4.2,
        // Dados de seguidores por mês
        followersByMonth: {
            categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
            series: [{
                    name: 'Seguidores',
                    data: [98000, 102000, 108000, 115000, 120000, 125000]
                }]
        },
        // Dados de engagement por post
        engagementByPost: {
            categories: ['Post 1', 'Post 2', 'Post 3', 'Post 4', 'Post 5'],
            series: [{
                    name: 'Curtidas',
                    data: [1250, 1890, 2100, 1750, 2300]
                }, {
                    name: 'Comentários',
                    data: [85, 120, 150, 95, 180]
                }]
        }
    },
    // ===== CHART DATA =====
    chartData: {
        salesByWeek: {
            categories: ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4', 'Sem 5', 'Sem 6', 'Sem 7', 'Sem 8'],
            series: [{
                    name: 'Vendas',
                    data: [12000, 15000, 18000, 14000, 22000, 19000, 25000, 28000]
                }]
        },
        productsByCategory: {
            categories: ['Eletrônicos', 'Roupas', 'Casa', 'Livros', 'Esportes'],
            series: [{
                    name: 'Produtos',
                    data: [45, 32, 28, 15, 12]
                }]
        },
        revenueByMonth: {
            categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
            series: [{
                    name: 'Receita',
                    data: [25000, 28000, 32000, 29000, 35000, 38000]
                }]
        }
    },
    // ===== DOCUMENTATION DATA =====
    carouselImages: [
        {
            id: '1',
            image: 'https://via.placeholder.com/1200x400/3B82F6/FFFFFF?text=Growth+Blocks+Dashboard',
            alt: 'Growth Blocks Dashboard',
            title: 'Dashboard Completo',
            description: 'Visualize todos os seus dados em um só lugar'
        },
        {
            id: '2',
            image: 'https://via.placeholder.com/1200x400/10B981/FFFFFF?text=Analytics+Avançado',
            alt: 'Analytics Avançado',
            title: 'Analytics Avançado',
            description: 'Insights detalhados sobre seu crescimento'
        },
        {
            id: '3',
            image: 'https://via.placeholder.com/1200x400/F59E0B/FFFFFF?text=Componentes+Reutilizáveis',
            alt: 'Componentes Reutilizáveis',
            title: 'Componentes Reutilizáveis',
            description: 'Biblioteca completa de componentes React'
        }
    ],
    components: [
        {
            id: 'dashboard-card',
            name: 'Dashboard Card',
            description: 'Cartão responsivo para exibir métricas e KPIs',
            image: 'https://via.placeholder.com/300x200/3B82F6/FFFFFF?text=Dashboard+Card',
            category: 'Dashboard',
            tags: ['React', 'TypeScript', 'Bootstrap'],
            version: '1.2.0',
            lastUpdated: '2025-01-15',
            status: 'Stable',
            downloads: 1250,
            rating: 4.8
        },
        {
            id: 'analytics-chart',
            name: 'Analytics Chart',
            description: 'Gráficos interativos para visualização de dados',
            image: 'https://via.placeholder.com/300x200/10B981/FFFFFF?text=Analytics+Chart',
            category: 'Analytics',
            tags: ['Chart.js', 'React', 'Data Viz'],
            version: '2.1.0',
            lastUpdated: '2025-01-14',
            status: 'Stable',
            downloads: 890,
            rating: 4.9
        },
        {
            id: 'user-table',
            name: 'User Table',
            description: 'Tabela avançada para gerenciamento de usuários',
            image: 'https://via.placeholder.com/300x200/F59E0B/FFFFFF?text=User+Table',
            category: 'Data',
            tags: ['Table', 'CRUD', 'Pagination'],
            version: '1.5.0',
            lastUpdated: '2025-01-13',
            status: 'Stable',
            downloads: 1100,
            rating: 4.7
        },
        {
            id: 'notification-system',
            name: 'Notification System',
            description: 'Sistema completo de notificações em tempo real',
            image: 'https://via.placeholder.com/300x200/EF4444/FFFFFF?text=Notifications',
            category: 'UI',
            tags: ['Notifications', 'Real-time', 'Toast'],
            version: '1.0.0',
            lastUpdated: '2025-01-12',
            status: 'Beta',
            downloads: 650,
            rating: 4.5
        },
        {
            id: 'form-builder',
            name: 'Form Builder',
            description: 'Construtor de formulários dinâmicos e validação',
            image: 'https://via.placeholder.com/300x200/8B5CF6/FFFFFF?text=Form+Builder',
            category: 'Forms',
            tags: ['Forms', 'Validation', 'Dynamic'],
            version: '1.3.0',
            lastUpdated: '2025-01-11',
            status: 'Stable',
            downloads: 780,
            rating: 4.6
        },
        {
            id: 'auth-guard',
            name: 'Auth Guard',
            description: 'Sistema de autenticação e autorização robusto',
            image: 'https://via.placeholder.com/300x200/06B6D4/FFFFFF?text=Auth+Guard',
            category: 'Security',
            tags: ['Auth', 'JWT', 'Permissions'],
            version: '2.0.0',
            lastUpdated: '2025-01-10',
            status: 'Stable',
            downloads: 1450,
            rating: 4.9
        }
    ]
};
